import Vue from 'vue'

const IconComponents = require.context('@/assets/icons', true)
IconComponents.keys().map((component) => {
  // turn './ComponentName.vue' into 'ComponentName'
  const componentName = component.replace(/^\.\//, '').replace(/\.vue$/, '')
  // register new component globally
  Vue.component(componentName, IconComponents(component).default)
})
